import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { PlusPointNode, VolantinoNode } from '@gql/graphql'
import { PDPInfoCard } from '@components/molecules'
import styles from './PDPInfoSlider.module.sass'
import { A11y, Navigation, Pagination } from 'swiper/modules'

interface Props {
  plusPoints?: PlusPointNode[]
  volantini?: VolantinoNode[]
  className?: string
}

const PDPInfoSlider = (props: Props) => {
  const { plusPoints = [], volantini = [], className = '' } = props

  return plusPoints.length > 0 || volantini.length > 0 ? (
    <div className={`${styles.root} ${className}`}>
      <Swiper
        spaceBetween={16}
        slidesPerView={'auto'}
        modules={[A11y, Navigation, Pagination]}
        navigation
        pagination={{
          type: 'progressbar',
        }}
        loop={plusPoints.length > 3 ? true : false}
        watchOverflow
        className={'swiper--bottomNav'}
      >
        {plusPoints.length > 0 &&
          plusPoints.map((x) => (
            <SwiperSlide key={x.pk}>
              <PDPInfoCard
                item={{
                  name: x.titolo,
                  description: x.descrizione,
                  image: x.immagine,
                }}
              />
            </SwiperSlide>
          ))}

        {volantini.length > 0 &&
          volantini.map((x) => (
            <SwiperSlide key={x.pk}>
              <PDPInfoCard
                item={{
                  name: x.titolo,
                  description: x.intro,
                  image: x.immagine,
                  url: x.url,
                }}
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  ) : (
    <></>
  )
}

export default PDPInfoSlider
